<div class="view-head">
  <div class="row">

    <div class="col-12 d-none d-md-block col-md-2">
      <div class="heading-filter">
        <h2>Expenses</h2>
      </div>
    </div>

    <div class="col-12 col-md-10 text-right header-container">

      <form [formGroup]="searchForm">
        <app-search-input #searchInput name="keywords" [parentForm]="searchForm"
          (inputChange)="onSearchInputChanged($event)">
        </app-search-input>
      </form>

      <app-expense-filters #expenseFilters (filtersChanged)="onFiltersChanged($event)"></app-expense-filters>

      <app-dropdown-input class="order-by-dropdown" #orderBySelect [options]="orderByOptions"></app-dropdown-input>

      <div class="button-container ml-0">
        <div class="flex gap-4 justify-end">
          <!-- <app-button text="Import" (clicked)="sebelaImportModal.show()" variant="secondary"
            *ngIf="authService.hasPermission(Permissions.ExpenseExportCsv) && !authService.hasRole(RoleNames.BlindedProjectCoordinatorExpenses)" /> -->
          <div class="flex gap-4 justify-end">
            <app-button text="Export" (clicked)="exportExpensesModal.show()" variant="secondary"
              *ngIf="authService.hasPermission(Permissions.ExpenseExportCsv) && !authService.hasRole(RoleNames.BlindedProjectCoordinatorExpenses)" />

            <app-button text="Create Expense" (clicked)="createExpenseModal.show()"
              *ngIf="authService.hasPermission(Permissions.ExpenseWrite) && !authService.hasRole(RoleNames.BlindedProjectCoordinatorExpenses)" />
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

<div class="view-body">

  <div class="std-tabbed-content">

    <div class="tabs-wrap">
      <app-mobile-tabs #mobileTabs (onSelected)="onTabSelect(ExpenseClaimState[$event])">
        <ul>
          <li>
            <a class="selected" (click)="mobileTabs.onSelectItem(ExpenseClaimState.Pending.toString(), $event)">
              Pending
              <span *ngIf="claimsCount">
                ({{claimsCount[getExpenseStateString(ExpenseClaimState.Pending)]}})
              </span>
            </a>
          </li>

          <li>
            <a (click)="mobileTabs.onSelectItem(ExpenseClaimState.Approved.toString(), $event)">
              Approved - Manual Payment
              <span *ngIf="claimsCount">
                ({{claimsCount[getExpenseStateString(ExpenseClaimState.Approved)]}})
              </span>
            </a>
          </li>

          <li>
            <a (click)="mobileTabs.onSelectItem(ExpenseClaimState.AutomatedPaymentApproved.toString(), $event)">
              Approved - Automated Payment
              <span *ngIf="claimsCount">
                ({{claimsCount[getExpenseStateString(ExpenseClaimState.AutomatedPaymentApproved)]}})
              </span>
            </a>
          </li>

          <li>
            <a (click)="mobileTabs.onSelectItem(ExpenseClaimState.Processing.toString(), $event)">
              Payment Processing
              <span *ngIf="claimsCount">
                ({{claimsCount[getExpenseStateString(ExpenseClaimState.Processing)]}})
              </span>
            </a>
          </li>

          <li>
            <a (click)="mobileTabs.onSelectItem(ExpenseClaimState.AutomatedPaymentFailed.toString(), $event)">
              Automated Payment Failed
              <span *ngIf="claimsCount">
                ({{claimsCount[getExpenseStateString(ExpenseClaimState.AutomatedPaymentFailed)]}})
              </span>
            </a>
          </li>

          <li>
            <a (click)="mobileTabs.onSelectItem(ExpenseClaimState.Paid.toString(), $event)">
              Paid
            </a>
          </li>

          <li>
            <a (click)="mobileTabs.onSelectItem(ExpenseClaimState.Rejected.toString(), $event)">
              Rejected
            </a>
          </li>
        </ul>
      </app-mobile-tabs>

      <ul class="nav nav-tabs">

        <li class="nav-item">
          <a (click)="onTabSelect(ExpenseClaimState.Pending)" class="nav-link"
            [ngClass]="{'active': selectedTab === ExpenseClaimState.Pending}">
            Pending
            <div class="tab-loading spinner-border spinner-border-sm" role="status" *ngIf="!claimsCount">
              <span class="sr-only">Loading...</span>
            </div>
            <span *ngIf="claimsCount">
              ({{claimsCount[getExpenseStateString(ExpenseClaimState.Pending)]}})
            </span>
          </a>
        </li>

        <li class="nav-item">
          <a (click)="onTabSelect(ExpenseClaimState.Approved)" class="nav-link"
            [ngClass]="{'active': selectedTab === ExpenseClaimState.Approved}">
            Approved - Manual Payment
            <div class="tab-loading spinner-border spinner-border-sm" role="status" *ngIf="!claimsCount">
              <span class="sr-only">Loading...</span>
            </div>
            <span *ngIf="claimsCount">
              ({{claimsCount[getExpenseStateString(ExpenseClaimState.Approved)]}})
            </span>
          </a>
        </li>

        <li class="nav-item">
          <a (click)="onTabSelect(ExpenseClaimState.AutomatedPaymentApproved)" class="nav-link"
            [ngClass]="{'active': selectedTab === ExpenseClaimState.AutomatedPaymentApproved}">
            Approved - Automated Payment
            <div class="tab-loading spinner-border spinner-border-sm" role="status" *ngIf="!claimsCount">
              <span class="sr-only">Loading...</span>
            </div>
            <span *ngIf="claimsCount">
              ({{claimsCount[getExpenseStateString(ExpenseClaimState.AutomatedPaymentApproved)]}})
            </span>
          </a>
        </li>

        <li class="nav-item">
          <a (click)="onTabSelect(ExpenseClaimState.Processing)" class="nav-link"
            [ngClass]="{'active': selectedTab === ExpenseClaimState.Processing}">
            Payment Processing
            <div class="tab-loading spinner-border spinner-border-sm" role="status" *ngIf="!claimsCount">
              <span class="sr-only">Loading...</span>
            </div>
            <span *ngIf="claimsCount">
              ({{claimsCount[getExpenseStateString(ExpenseClaimState.Processing)]}})
            </span>
          </a>
        </li>

        <li class="nav-item">
          <a (click)="onTabSelect(ExpenseClaimState.AutomatedPaymentFailed)" class="nav-link"
            [ngClass]="{'active': selectedTab === ExpenseClaimState.AutomatedPaymentFailed}">
            Automated Payment Failed
            <div class="tab-loading spinner-border spinner-border-sm" role="status" *ngIf="!claimsCount">
              <span class="sr-only">Loading...</span>
            </div>
            <span *ngIf="claimsCount">
              ({{claimsCount[getExpenseStateString(ExpenseClaimState.AutomatedPaymentFailed)]}})
            </span>
          </a>
        </li>

        <li class="nav-item">
          <a (click)="onTabSelect(ExpenseClaimState.Paid)" class="nav-link"
            [ngClass]="{'active': selectedTab === ExpenseClaimState.Paid}">Paid</a>
        </li>

        <li class="nav-item">
          <a (click)="onTabSelect(ExpenseClaimState.Rejected)" class="nav-link"
            [ngClass]="{'active': selectedTab === ExpenseClaimState.Rejected}">Rejected</a>
        </li>
      </ul>
    </div>

    <div class="results-wrap">

      <div class="tab-content">

        <!-- Start: Expenses -->
        <div *ngIf="dataLoaded" class="tab-pane fade show active" id="expenses-container">
          <div *ngIf="!isCaxtonTab()">
            <div class="expense-details" *ngFor="let expense of claimsResponse.results">
              <app-expense-details-head [expense]="expense" [dataLoaded]="dataLoaded"
                (searchFilter)="onPatientFilter($event)" (trialFilter)="onTrialFilter($event)"></app-expense-details-head>

              <div class="expense-container">
                <div class="expense-data">
                  <app-expense-state-badge [expense]="expense" [dataLoaded]="dataLoaded"
                    [selectedTab]="selectedTab"></app-expense-state-badge>
                  <app-expense-meta-data [expense]="expense" [dataLoaded]="dataLoaded" [selectedTab]="selectedTab"
                    (filterByVisit)="setSearch($event)"></app-expense-meta-data>
                  <app-expense-cost [expense]="expense" [dataLoaded]="dataLoaded"
                    [selectedTab]="selectedTab"></app-expense-cost>
                  <app-expense-check-preview [expense]="expense"></app-expense-check-preview>
                  <app-expense-description [expense]="expense" [selectedTab]="selectedTab"></app-expense-description>
                  <app-expense-reject-reason [expense]="expense"></app-expense-reject-reason>
                  <app-expense-images [enableImagesManagement]="expense.state !== ExpenseClaimState.Rejected && authService.hasPermission(Permissions.ExpenseWrite)"
                    [receipts]="expense.receipts" [imagery]="expense.imageUrls"
                    [expenseClaimId]="expense.id" [claimCategory]="expense.categoryName"
                    [claimAmount]="expense.amount" [claimCurrency]="expense.currency" [visitDate]="expense.visitDate" [visitEndDate]="expense.visitEndDate" [visitTravelDays]="expense.visitTravelDays"></app-expense-images>
                  <app-expense-edit-reasons [expense]="expense" [selectedTab]="selectedTab"></app-expense-edit-reasons>

                  <div class="pt-4">
                    <app-button text="Preload Redemption" (clicked)="onPreloadRedemptionClick(expense)"
                      size="sm"
                      [visible]="(expense.state === ExpenseClaimState.Pending || expense.state === ExpenseClaimState.Paid) &&  expense.subCategory === 1" />
                  </div>
                </div>
                <div class="expense-actions-container">
                  <app-expense-actions [expense]="expense" [selectedTab]="selectedTab" [dataLoaded]="dataLoaded"
                    [processingRequest]="processingRequest" (edit)="onEditExpense($event)"
                    (check)="onCheckExpense($event)" (clone)="onCloneExpense($event)"
                    (approve)="onApproveExpenseClaim($event)" (markAsPaid)="onMarkAsPaid($event)"
                    (reject)="onRejectModal($event)" (revertToPending)="confirmRevertModal.showConfirmation($event)"
                    (startInvestigation)="showStartInvestigationModal($event)"
                    (closeInvestigation)="onCloseInvestigation($event)"
                    (refreshResult)="loadPage(page, keywords, selectedTab)">
                  </app-expense-actions>
                </div>
              </div>

            </div>
          </div>

          <div *ngIf="isCaxtonTab()">
            <div *ngFor="let patientGroupExpense of caxtonClaimsResponse.results">
              <div class="expense-details" *ngFor="let expenses of patientGroupExpense.currencyGroupExpenses">

                <app-expense-caxton-details-head [expense]="expenses" [dataLoaded]="dataLoaded"
                  (searchFilter)="onPatientFilter($event)" (trialFilter)="onTrialFilter($event)"></app-expense-caxton-details-head>

                <div [ngClass]="{'processing-min-height': selectedTab === ExpenseClaimState.Processing}"
                  class="expense-wrapper" *ngFor="let expense of expenses.expenses">

                  <app-expense-state-badge [expense]="expense" [selectedTab]="selectedTab"
                    [dataLoaded]="dataLoaded"></app-expense-state-badge>

                  <div class="add-note-btn">
                    <app-button text="Add Note" (clicked)="openAddNoteModal(expense)" variant="secondary" size="sm" />
                  </div>

                  <app-expense-meta-data [expense]="expense" [selectedTab]="selectedTab" [dataLoaded]="dataLoaded"
                    (filterByVisit)="setSearch($event)"></app-expense-meta-data>
                  <app-expense-cost [expense]="expense" [selectedTab]="selectedTab"
                    [dataLoaded]="dataLoaded"></app-expense-cost>
                  <app-expense-caxton-payment-dates [expense]="expense" [dataLoaded]="dataLoaded"
                    [selectedTab]="selectedTab"></app-expense-caxton-payment-dates>
                  <app-expense-description [expense]="expense" [selectedTab]="selectedTab"></app-expense-description>
                  <app-expense-images [imagery]="expense.imageUrls"></app-expense-images>
                  <app-expense-edit-reasons [expense]="expense" [selectedTab]="selectedTab"></app-expense-edit-reasons>
                </div>

                <app-expense-caxton-payment-actions [expenses]="expenses" [selectedTab]="selectedTab"
                  [dataLoaded]="dataLoaded" [processingRequest]="processingRequest"
                  (automatedPaymentFailed)="moveToAutomatedPaymentFailed($event)"
                  (checkNmibleStatus)="checkStatusOnNmible($event)"
                  (sendToFinance)="sendToFinance($event)" (payByBank)="payByCaxtonBank($event)"
                  (payByCard)="payByCaxtonCard($event)" (payByNmible)="payByNmible($event)" (payByNmibleBank)="payByNmibleBank($event)"
                  (unloadFromCard)="unloadFromCaxtonCard($event)" (investigation)="openCloseInvestigationModal($event)"
                  (transfer)="showCaxtonTransferModal($event.totalExpense, $event.patientName, $event.expenses, $event.paymentMethod)"
                  (updateNmiblePaymentStatusManually)="onUpdateNmiblePaymentStatusManually($event)">
                </app-expense-caxton-payment-actions>

              </div>
            </div>
          </div>

        </div>
        <!-- End: Expenses -->

        <div *ngIf="!dataLoaded" id="expenses-pending">
          <div *ngIf="!isCaxtonTab()">
            <div class="expense-details" *ngFor="let _ of loaderArray">
              <app-expense-details-head [dataLoaded]="dataLoaded"></app-expense-details-head>

              <div class="expense-container">
                <div class="expense-data">
                  <app-expense-state-badge [dataLoaded]="dataLoaded"
                    [selectedTab]="selectedTab"></app-expense-state-badge>
                  <app-expense-meta-data [dataLoaded]="dataLoaded" [selectedTab]="selectedTab"></app-expense-meta-data>
                  <app-expense-cost [dataLoaded]="dataLoaded" [selectedTab]="selectedTab"></app-expense-cost>
                </div>
                <div class="expense-actions-container">
                  <app-expense-actions [dataLoaded]="dataLoaded" [selectedTab]="selectedTab"></app-expense-actions>
                </div>
              </div>

            </div>
          </div>

          <div *ngIf="isCaxtonTab()">
            <div *ngFor="let _ of loaderArray">
              <div class="expense-details" *ngFor="let expenses of [1]">

                <app-expense-caxton-details-head [dataLoaded]="dataLoaded"
                  (searchFilter)="setSearch($event.label)"></app-expense-caxton-details-head>

                <div [ngClass]="{'processing-min-height': selectedTab === ExpenseClaimState.Processing}"
                  class="expense-wrapper" *ngFor="let _ of [1,1]">

                  <app-expense-state-badge [dataLoaded]="dataLoaded"
                    [selectedTab]="selectedTab"></app-expense-state-badge>

                  <app-expense-meta-data [dataLoaded]="dataLoaded" [selectedTab]="selectedTab"></app-expense-meta-data>
                  <app-expense-cost [dataLoaded]="dataLoaded" [selectedTab]="selectedTab"></app-expense-cost>
                  <app-expense-caxton-payment-dates [dataLoaded]="dataLoaded"
                    [selectedTab]="selectedTab"></app-expense-caxton-payment-dates>
                </div>

                <app-expense-caxton-payment-actions [dataLoaded]="dataLoaded" [selectedTab]="selectedTab">
                </app-expense-caxton-payment-actions>

              </div>
            </div>
          </div>
        </div>

        <app-pagination *ngIf="!noResultsVisible()"
          [currentPage]="isCaxtonTab() ? caxtonClaimsResponse?.currentPage : claimsResponse?.currentPage"
          [totalPageCount]="isCaxtonTab() ? caxtonClaimsResponse?.totalPageCount : claimsResponse?.totalPageCount"
          (pageSelected)="loadPage($event, keywords, selectedTab)">
        </app-pagination>

        <div *ngIf="noResultsVisible()">
          <div class="no-results inside">
            <div class="inner">
              <div class="image">
                <img [src]="noResultsImage()" [alt]="noResultsText()" />
              </div>
              <div class="content">
                <h2>{{ noResultsText() }}</h2>
                <p *ngIf="noSearchMatchingResults()">
                  There are no expenses matching your search.
                </p>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<app-modal #cloneAttachmentsModal>
  <div class="modal-content">
    <div class="modal-header">
      <h2 class="modal-title">Clone Expense?</h2>
    </div>

    <div class="modal-body">
      <p>
        Do you want to include expense receipt attachments when cloning this
        expense?
      </p>
    </div>

    <div class="modal-footer">
      <div class="row">
        <div class="col-4">
          <app-button text="Cancel" (clicked)="onCancelClone()" variant="secondary" width="fill" />
        </div>

        <div class="col-4">
          <app-button text="No" (clicked)="onCloneWithoutAttachments()" variant="secondary" width="fill" />
        </div>

        <div class="col-4">
          <app-button text="Yes" (clicked)="onCloneWithAttachments()" width="fill" />
        </div>
      </div>
    </div>
  </div>
</app-modal>

<app-modal #approveDistanceModal>
  <div class="modal-content">
    <div class="modal-header">
      <h2 class="modal-title">Approve Distance Expense?</h2>
    </div>
    <div class="modal-body">
      <form class="modal-form-full-width" [formGroup]="approveDistanceForm">
        <div class="form-group">
          <label>Currency</label>
          <app-dropdown-input #currencySelect name="currency" [parentForm]="approveDistanceForm"
            [options]="currencyOptions" placeholder="Select Currency..."
            (selectValueChanged)="onCurrencySelectChanged($event)"></app-dropdown-input>
        </div>
        <div class="form-group">
          <label>Amount</label>
          <input type="number" class="form-control" formControlName="amount">
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <div class="row">
        <div class="col-6">
          <app-button text="Cancel" (clicked)="approveDistanceModal.hide()" variant="secondary" width="fill" />
        </div>

        <div class="col-6">
          <app-button text="Approve"
                      (clicked)="onApproveDistanceExpenseClaim()"
                      [disabled]="approveDistanceForm.invalid || processingDistanceApproveRequest"
                      [isBusy]="processingDistanceApproveRequest"
                      width="fill" />
        </div>
      </div>
    </div>
  </div>
</app-modal>

<app-modal #rejectExpenseModal>
  <div class="modal-content">
    <div class="modal-header">
      <h2 class="modal-title">Reject Expense</h2>
    </div>
    <div class="modal-body">
      <p>This rejection reason will be displayed to the patient in their app.</p>
      <form class="modal-form-full-width" [formGroup]="rejectForm">
        <div class="form-group">
          <label>Rejection Reason</label>
          <textarea class="form-control" formControlName="reason"></textarea>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <div class="row">
        <div class="col-6">
          <app-button text="Cancel" (clicked)="rejectExpenseModal.hide()" variant="secondary" width="fill" />
        </div>

        <div class="col-6">
          <app-button text="Reject"
                      (clicked)="onConfirmRejectExpense()"
                      [disabled]="!rejectForm.valid"
                      [isBusy]="rejectFormIsProcessing"
                      width="fill" />
        </div>
      </div>
    </div>
  </div>
</app-modal>

<!-- Start: Export expenses modal -->
<app-modal #exportExpensesModal>
  <div class="modal-header">
    <h2 class="modal-title">Export</h2>
  </div>
  <div class="modal-body">
    <form class="modal-form-full-width" [formGroup]="exportForm">
      <div class="form-group">
        <label>Start Date</label>
        <input type="text" #dateFrom class="date" data-toggle="datepicker" formControlName="dateFrom">
      </div>
      <div class="form-group">
        <label>End Date</label>
        <input type="text" #dateTo class="date" data-toggle="datepicker" formControlName="dateTo">
      </div>
      <div class="form-group">
        <label>Filter by</label>
        <app-dropdown-input #expenseExportFilterBy [options]="exportDateOptions" placeholder="Select..."
          [parentForm]="exportForm" name="filterBy" (selectValueChanged)="onExportDateOptionChanged($event)"
          [selectedValue]="'0'">
        </app-dropdown-input>
      </div>
      <div class="form-group">
        <label class="checkbox">
          <input formControlName="allTrials" id="all-trials" type="checkbox" value="true">
          <span></span>
        </label>
        <label class="checkbox-label" for="all-trials">All trials</label>
      </div>
      <div class="form-group" [class.visibility-hidden]="exportForm.get('allTrials').value === true">
        <label>Trial</label>
        <app-trial-autocomplete #trialAutocomplete [form]="exportForm" controlName="trialId"
          (valueChanged)="onTrialChanged($event)" placeholder="Select a trial..."></app-trial-autocomplete>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-6">
        <app-button text="Cancel" (clicked)="closeExportModal()" variant="secondary" width="fill" />
      </div>

      <div class="col-6" (mousemove)="updateExportFormValues()">
        <app-button text="Export"
                    (clicked)="onExport()"
                    [disabled]="exportForm.invalid"
                    [isBusy]="exportIsProcessing"
                    width="fill" />

      </div>
    </div>
  </div>
</app-modal>
<!-- End: Export expenses modal -->

<app-modal #sebelaImportModal>
  <div class="modal-header">
    <h2 class="modal-title">Import Expenses</h2>
  </div>
  <div class="modal-body">
    <form class="modal-form-full-width" [formGroup]="sebelaImportForm">
      <div class="form-group">
        <label>Import type:</label>
        <app-dropdown-input
          name="importType"
          [parentForm]="sebelaImportForm"
          [options]="importTypeOptions"
          [selectedValue]="'sebela-ediary'">
        </app-dropdown-input>
      </div>
      <div class="form-group">
        <label>Excel file to import:</label>
        <div class="upload-area"
             (dragover)="onSebelaImportDragOver($event)"
             (dragleave)="onSebelaImportDragLeave($event)"
             (drop)="onSebelaImportDrop($event)"
             [class.drag-over]="sebelaImportDragOver">
          <i class="far fa-upload fa-2x mb-2"></i>
          <div *ngIf="!sebelaImportForm.get('file').value" class="upload-area-hint">Drop a CSV file here or</div>
          <div *ngIf="sebelaImportForm.get('file').value" class="upload-area-filename">{{ sebelaImportForm.get('file').value.name }}</div>
          <a class="btn btn-outline btn-slim btn-add-ticket" (click)="sebelaFilePicker.click()">+ Add document</a>
        </div>
        <input type="file" #sebelaFilePicker style="display: none" (change)="sebelaImportFileSelected($event)" accept=".csv" />
      </div>
    </form>
    <pgo-callout *ngIf="sebelaImportState == SebelaImportValidationResult.Failed"
      variant="danger"
      title="Validation Failed"
      size="sm">
      {{ sebelaImportFailureReason }}
    </pgo-callout>
    <pgo-callout *ngIf="sebelaImportState == SebelaImportValidationResult.Verified"
      variant="success"
      title="Validation Passed"
      size="sm">
      <p class="mb-1">{{ sebelaImportValidationResponse.numberOfSingleCyclePatientUpdates }} patient{{
        sebelaImportValidationResponse.numberOfSingleCyclePatientUpdates !== 1 ? 's' : '' }} will be paid for 1x e-diary cycle</p>
      <p class="mb-0">{{ sebelaImportValidationResponse.numberOfMultiCyclePatientUpdates }} patient{{
        sebelaImportValidationResponse.numberOfMultiCyclePatientUpdates !== 1 ? 's' : '' }} will be paid for &gt; 1x e-diary cycle</p>
    </pgo-callout>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-6">
        <app-button text="Cancel" (clicked)="closeSebelaImportModal()" variant="secondary" width="fill" />
      </div>

      <div class="col-6">
        @if (sebelaImportState !== SebelaImportValidationResult.Verified) {
          <app-button text="Import"
                      (clicked)="onSebelaImportVerify()"
                      [disabled]="sebelaImportForm.invalid"
                      [isBusy]="sebelaImportIsProcessing"
                      width="fill" />
        }

        @if (sebelaImportState == SebelaImportValidationResult.Verified) {
          <app-button text="Confirm Import"
                      (clicked)="onSebelaImportConfirm()"
                      [disabled]="sebelaImportIsProcessing"
                      [isBusy]="sebelaImportIsProcessing"
                      width="fill" />
        }
      </div>
    </div>
  </div>
</app-modal>
<!-- End: e-diary import modal -->

<app-modal #foundOnCaxtonModal>
  <div class="modal-content">
    <div class="modal-header">
      <h2 class="modal-title">Caxton Transfer ID</h2>
    </div>
    <div class="modal-body found-on-caxton">

      <form [formGroup]="foundOnCaxtonForm">
        <table aria-hidden="true" class="simple-form">
          <tbody>

            <tr>
              <th class="valign-top"><label class="info-label">Amount</label></th>
              <td>
                <div class="form-group">
                  <label class="caxton-transfer-details">
                    <span *ngIf="caxtonTransferModalExpensesArePreloadRedemption" class="negative-amount">-</span>
                    {{caxtonTransferModalAmount | number: '1.2-2' }}
                    {{caxtonTransferModalCurrency}}
                  </label>
                </div>
              </td>
            </tr>

            <tr>
              <th class="valign-top"><label class="info-label">Recipient</label></th>
              <td>
                <div class="form-group">
                  <label class="caxton-transfer-details">{{caxtonTransferModalRecipient}}</label>
                </div>
              </td>
            </tr>

            <tr>
              <th class="valign-top"><label class="info-label">Date & Time</label></th>
              <td>
                <div class="form-group">
                  <label class="caxton-transfer-details">{{caxtonTransferModalDate | date:'dd/MM/yyyy - hh:mm'}}</label>
                </div>
              </td>
            </tr>

            <tr *ngIf="caxtonTransferModalPaymentMethod === ExpenseClaimPaymentMethod.CaxtonAutomatedBankTransfer">
              <th class="valign-top"><label class="label-input" for="transfer-id">Transfer ID</label></th>
              <td>
                <div class="form-group">
                  <input type="number" class="form-control" formControlName="transferId" id="transfer-id">
                </div>
              </td>
            </tr>

            <tr>
              <th class="valign-top"><label class="label-input" for="findings">Findings</label></th>
              <td>
                <div class="form-group">
                  <textarea class="form-control" formControlName="caxtonFailedFindings" id="findings"></textarea>
                </div>
              </td>
            </tr>

          </tbody>
        </table>

      </form>

    </div>
    <div class="modal-footer">

      <div class="row">
        <div class="col-6">
          <app-button text="Cancel" (clicked)="hideFoundOnCaxtonModal()" variant="secondary" width="fill" />
        </div>

        <div class="col-6">
          <app-button text="Save"
                      (clicked)="setCaxtonTransferId()"
                      [disabled]="!foundOnCaxtonForm.valid"
                      [isBusy]="foundOnCaxtonFormProcessing"
                      width="fill" />
        </div>

      </div>
    </div>
  </div>
</app-modal>
<!-- Start: Send to Finance modal -->

<app-modal #sendToFinanceModal>
  <div class="modal-header">
    <h2 class="modal-title">Process as manual payment ?</h2>
  </div>
  <div class="modal-body">
    <label class="label-input">Reason</label>
    <textarea class="form-control send-to-finance-reason" #sendToFinanceReason></textarea>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-6">
        <app-button text="Cancel" (clicked)="sendToFinanceModal.hide()" variant="secondary" width="fill" />
      </div>

      <div class="col-6">
        <app-button text="Process as manual payment"
                    (clicked)="onConfirmSendToFinance()"
                    [isBusy]="processingRequest"
                    width="fill" />
      </div>
    </div>
  </div>
</app-modal>
<!-- End: Send to Finance modal -->

<app-modal #confirmExpenseApprove>
  <div class="modal-content">
    <div class="modal-header">
      <h2 class="modal-title">Expense will go to manual payment</h2>
    </div>
    <div class="modal-body">
      <p>{{caxtonIncompatibleData?.caxtonIncompatibleReason.split('|')[0]}}</p>
    </div>
    <div class="modal-footer">
      <div class="row">
        <div class="col-6">
          <app-button text="Cancel" (clicked)="closeConfirmExpenseApproveModal()" variant="secondary" width="fill" />
        </div>

        <div class="col-6">
          <app-button text="Continue"
                      (clicked)="confirmExpenseClaimApproval()"
                      [disabled]="confirmExpenseClaimApprovalProcessing"
                      [isBusy]="confirmExpenseClaimApprovalProcessing"
                      width="fill" />
        </div>
      </div>
    </div>
  </div>
</app-modal>

<app-modal #caxtonFailedFindingModal>
  <div class="modal-content">
    <div class="modal-header">
      <h2 class="modal-title">Add failure findings</h2>
    </div>
    <div class="modal-body">
      <label class="label-input">Findings</label>
      <textarea class="form-control send-to-finance-reason" #caxtonFailedFinding></textarea>
    </div>
    <div class="modal-footer">
      <div class="row">
        <div class="col-6">
          <app-button text="Cancel" (clicked)="closeCaxtonFailedFindingModal()" variant="secondary" width="fill" />
        </div>

        <div class="col-6">
          <app-button text="Continue"
                      (clicked)="closeInvestigation()"
                      [isBusy]="processingRequest"
                      width="fill" />
        </div>
      </div>
    </div>
  </div>
</app-modal>

<app-confirm-action-modal #confirmRevertModal (confirmed)="onRevertToPending($event)" title="Revert Expense to Pending?"
  message="Are you sure you want to revert this expense claim from Approved to Pending?"
  confirmBtnText="Yes, Revert"></app-confirm-action-modal>
<app-expense-add-notes #addNoteModal (noteAdded)="getExpenses()"></app-expense-add-notes>
<app-create-expense-modal #createExpenseModal (expenseCreated)="getExpenses()"></app-create-expense-modal>
<app-start-investigation-modal #startInvestigationModal
  (refreshResult)="loadPage(page, keywords, selectedTab)"></app-start-investigation-modal>
<app-close-investigation-modal #closeInvestigationModal
  (refreshResult)="loadPage(page, keywords, selectedTab)"></app-close-investigation-modal>
<app-edit-expense-modal #editExpenseModal (expenseUpdated)="getExpenses()"></app-edit-expense-modal>
<app-check-expense-modal #checkExpenseModal (expenseClaimUpdated)="getExpenses()" (suggested)="getExpenses()"
  (saved)="getExpenses()" (approved)="onApproveExpenseClaim($event)" (rejected)="onRejectModal($event.id)"
  (overBudgetRequestRaised)="onOverBudgetRequestRaised()"></app-check-expense-modal>
<app-duplicate-expense-modal #duplicateExpenseModal (cloned)="getExpenses()"></app-duplicate-expense-modal>
